module.exports = __webpack_public_path__ + "static/media/menteeBadge.6970c923.png";